import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';
import { Logger } from '@core/services/logger.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'cass-payment-result',
	templateUrl: './payment-result.component.html',
	styleUrls: ['./payment-result.component.css']
})
export class PaymentResultComponent implements OnInit {

	private readonly COMPONENT_NAME = "PaymentResultComponent";

	isPaymentSucceeded = false;
	orderNumber?: string;

	constructor(
		private logger: Logger,
		private route: ActivatedRoute,
		private router: Router,
		private localStorageService: LocalStorageService,
		private translate: TranslateService,
		private titleService: Title) {

		const result: string = this.route.snapshot.queryParams['result'] || "Fail";

		if (result.toUpperCase() === 'SUCCESS') {
			this.isPaymentSucceeded = true;
		}
		this.orderNumber = this.route.snapshot.queryParams['ORDER_NUMBER'] || this.route.snapshot.queryParams['checkout-reference'] || "Not provided";
	}

	tryAgain(): void {
		this.logger.debug(this.COMPONENT_NAME, `User selected the Try Again option for failed payment for orderId="${this.orderNumber}"`);
		if (this.localStorageService.isOrderStored()) {
			this.logger.info(this.COMPONENT_NAME, `The order is found in the browser's storage. Activating the Edit Local Order route for orderId="${this.orderNumber}"`);
			this.router.navigate(["edit"]);
		}
		else {
			// no order stored - go home
			this.logger.info(this.COMPONENT_NAME, "The order is NOT found in the browser's storage. Navigating home...");
			this.router.navigate([""]);
		}
	}

	ngOnInit(): void {
		this.logger.info(this.COMPONENT_NAME, "Payment result: starting...");
		this.translate.get("APP.TITLE").toPromise().then((title) => this.titleService.setTitle(title));

		if (this.isPaymentSucceeded) {
			this.localStorageService.clearOrder();
			this.logger.info(this.COMPONENT_NAME, `Payment result: payment succeeded, orderId="${this.orderNumber}"`);
		}
		else {
			this.logger.info(this.COMPONENT_NAME, `Payment result: payment failed, orderId="${this.orderNumber}"`);
		}
		this.logger.uploadLogs();
	}
}
